var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.663 14.512h-4.276V8.775h3.488c.619 0 1.125-.45 1.125-1.125V1.687c0-.618-.45-1.125-1.125-1.125h-4.106c-4.444 0-7.538 3.15-7.538 7.82V14.4h-4.95c-.787 0-1.518.619-1.518 1.519v4.05a1.51 1.51 0 0 0 1.518 1.518h4.838V33.92c0 .787.619 1.519 1.518 1.519h5.288c.337 0 .619-.17.844-.394.225-.225.394-.619.394-.956V21.543h3.712c.731 0 1.294-.45 1.406-1.125v-.113l.788-3.881c.056-.394 0-.844-.338-1.294-.112-.281-.619-.562-1.069-.619Z",
    fill: "#292723"
  })));
};
export default SvgFacebook;